var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDislikeTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 20)",
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19922 9.69981C9.19922 10.1969 9.60216 10.5998 10.0992 10.5998C10.5963 10.5998 10.9992 10.1969 10.9992 9.69981V6.09981C10.9992 5.60275 10.5963 5.19981 10.0992 5.19981C9.60216 5.19981 9.19922 5.60275 9.19922 6.09981V9.69981Z",
    stroke: "#6B7280",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5992 9.79981V6.54145C11.5992 6.08692 11.856 5.6714 12.2626 5.46813L12.2925 5.45318C12.6257 5.28655 12.9932 5.19981 13.3658 5.19981H16.6155C17.1875 5.19981 17.68 5.60356 17.7921 6.16447L18.5121 9.76447C18.6607 10.507 18.0927 11.1998 17.3355 11.1998H15.1992V13.5998C15.1992 14.2625 14.662 14.7998 13.9992 14.7998C13.6678 14.7998 13.3992 14.5312 13.3992 14.1998V13.7998C13.3992 13.2805 13.2308 12.7752 12.9192 12.3598L12.0792 11.2398C11.7676 10.8244 11.5992 10.3191 11.5992 9.79981Z",
    stroke: "#6B7280",
    strokeWidth: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeTable);
export default __webpack_public_path__ + "static/media/DislikeTable.5f3f66f4a2a3f922755570efac6fdfde.svg";
export { ForwardRef as ReactComponent };